// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Caregivers-module__font-s-10___nKddB {
  font-size: 10px !important;
}

.Caregivers-module__font-s-12___Htne_ {
  font-size: 12px !important;
}

.Caregivers-module__font-s-13___vNkSj {
  font-size: 13px !important;
}

.Caregivers-module__font-s-14___QF0eZ {
  font-size: 14px !important;
}

.Caregivers-module__font-s-15___WAixI {
  font-size: 15px !important;
}

.Caregivers-module__font-s-16___yOdS0 {
  font-size: 16px !important;
}

.Caregivers-module__font-s-18___oJT1j {
  font-size: 18px !important;
}

.Caregivers-module__font-s-20___P78JS {
  font-size: 20px !important;
}

.Caregivers-module__font-s-22___c_ZBJ {
  font-size: 22px !important;
}

.Caregivers-module__font-s-28___mrBcN {
  font-size: 28px !important;
}

.Caregivers-module__font-w-400___BXDWN {
  font-weight: 400 !important;
}

.Caregivers-module__font-w-500___AKvYH {
  font-weight: 500 !important;
}

.Caregivers-module__font-w-600___bVckh {
  font-weight: 600 !important;
}

.Caregivers-module__font-w-700___UlhqK {
  font-weight: 700 !important;
}

.Caregivers-module__p-5___aDhjv {
  padding: 5px !important;
}

.Caregivers-module__p-12___srYSE {
  padding: 12px !important;
}

.Caregivers-module__p-16___lpLC_ {
  padding: 16px !important;
}

.Caregivers-module__p-30___ZIwoZ {
  padding: 30px !important;
}

.Caregivers-module__p-b-0___YGl9J {
  padding-bottom: 0 !important;
}

.Caregivers-module__p-b-5___UzKN2 {
  padding-bottom: 5px !important;
}

.Caregivers-module__p-b-10___BvTLP {
  padding-bottom: 10px !important;
}

.Caregivers-module__p-b-12___v60VV {
  padding-bottom: 12px !important;
}

.Caregivers-module__p-b-16___QaybZ {
  padding-bottom: 16px !important;
}

.Caregivers-module__p-b-18___zihI7 {
  padding-bottom: 18px !important;
}

.Caregivers-module__p-b-20___x37cV {
  padding-bottom: 20px !important;
}

.Caregivers-module__p-b-25___Y7lSP {
  padding-bottom: 25px !important;
}

.Caregivers-module__p-b-30___ogUDZ {
  padding-bottom: 30px !important;
}

.Caregivers-module__p-b-50___kYkjH {
  padding-bottom: 50px !important;
}

.Caregivers-module__p-t-0___vZMzh {
  padding-top: 0 !important;
}

.Caregivers-module__p-t-12___LmNGo {
  padding-top: 12px !important;
}

.Caregivers-module__p-t-16___T3Hrc {
  padding-top: 16px !important;
}

.Caregivers-module__p-t-18___vD2JH {
  padding-top: 18px !important;
}

.Caregivers-module__p-t-20___eBAjR {
  padding-top: 20px !important;
}

.Caregivers-module__p-t-30___ViLFQ {
  padding-top: 30px !important;
}

.Caregivers-module__p-t-40___orXn7 {
  padding-top: 40px !important;
}

.Caregivers-module__p-t-50___Ykzoc {
  padding-top: 50px !important;
}

.Caregivers-module__p-l-20___mNPT8 {
  padding-left: 20px !important;
}

.Caregivers-module__p-l-30___rE9xv {
  padding-left: 30px !important;
}

.Caregivers-module__p-l-40___lMhzE {
  padding-left: 40px !important;
}

.Caregivers-module__p-r-16___CUxfc {
  padding-right: 16px !important;
}

.Caregivers-module__p-r-20___Gi_3H {
  padding-right: 20px !important;
}

.Caregivers-module__p-r-30___YljDW {
  padding-right: 30px !important;
}

.Caregivers-module__p-r-50___sOdDh {
  padding-right: 50px !important;
}

.Caregivers-module__p-r-60___cCHE2 {
  padding-right: 60px !important;
}

.Caregivers-module__m-b-1___S28Cy {
  margin-bottom: 1px !important;
}

.Caregivers-module__m-b-2___PdoSX {
  margin-bottom: 2px !important;
}

.Caregivers-module__m-b-6___VRVoi {
  margin-bottom: 6px !important;
}

.Caregivers-module__m-b-8___IBa9B {
  margin-bottom: 8px !important;
}

.Caregivers-module__m-b-10___JnaiQ {
  margin-bottom: 10px !important;
}

.Caregivers-module__m-b-14___Oz1UR {
  margin-bottom: 14px !important;
}

.Caregivers-module__m-b-16___rGAMj {
  margin-bottom: 16px !important;
}

.Caregivers-module__m-b-20___PMpUT {
  margin-bottom: 20px !important;
}

.Caregivers-module__m-b-22___j5QwL {
  margin-bottom: 22px !important;
}

.Caregivers-module__m-b-24___WqH9O {
  margin-bottom: 24px !important;
}

.Caregivers-module__m-b-30___kc39a {
  margin-bottom: 30px !important;
}

.Caregivers-module__m-b-32___XUvbF {
  margin-bottom: 32px !important;
}

.Caregivers-module__m-b-40___rxxLS {
  margin-bottom: 40px !important;
}

.Caregivers-module__m-t-2___PEiOk {
  margin-top: 2px !important;
}

.Caregivers-module__m-t-3___NIHTx {
  margin-top: 3px !important;
}

.Caregivers-module__m-t-4___q9sZI {
  margin-top: 4px !important;
}

.Caregivers-module__m-t-5___q8tVi {
  margin-top: 5px !important;
}

.Caregivers-module__m-t-8___Ge3R5 {
  margin-top: 8px !important;
}

.Caregivers-module__m-t-10___HGcLC {
  margin-top: 10px !important;
}

.Caregivers-module__m-t-15___qjsIz {
  margin-top: 15px !important;
}

.Caregivers-module__m-t-16___dD5AR {
  margin-top: 16px !important;
}

.Caregivers-module__m-t-20___xjAZr {
  margin-top: 20px !important;
}

.Caregivers-module__m-t-22___ZIzTP {
  margin-top: 22px !important;
}

.Caregivers-module__m-t-30___XrAbX {
  margin-top: 30px !important;
}

.Caregivers-module__m-t-32___c5ewu {
  margin-top: 32px !important;
}

.Caregivers-module__m-l-auto___P9Uxk {
  margin-left: auto !important;
}

.Caregivers-module__m-l-4___s1bCJ {
  margin-left: 4px !important;
}

.Caregivers-module__m-l-5___yhWZC {
  margin-left: 5px !important;
}

.Caregivers-module__m-l-6___WU5SE {
  margin-left: 6px !important;
}

.Caregivers-module__m-l-8___beZSr {
  margin-left: 8px !important;
}

.Caregivers-module__m-l-10___PqSIC {
  margin-left: 10px !important;
}

.Caregivers-module__m-l-16____9jyS {
  margin-left: 16px !important;
}

.Caregivers-module__m-l-20___ajvZC {
  margin-left: 20px !important;
}

.Caregivers-module__m-l-24___YTij6 {
  margin-left: 24px !important;
}

.Caregivers-module__m-l-30___yNDde {
  margin-left: 30px !important;
}

.Caregivers-module__m-l-35___GAeLk {
  margin-left: 35px !important;
}

.Caregivers-module__m-l-40___rkGgU {
  margin-left: 40px !important;
}

.Caregivers-module__m-r-8___spZHz {
  margin-right: 8px !important;
}

.Caregivers-module__m-r-10___XB83t {
  margin-right: 10px !important;
}

.Caregivers-module__m-r-16___nEVGf {
  margin-right: 16px !important;
}

.Caregivers-module__m-r-20___syhtC {
  margin-right: 20px !important;
}

.Caregivers-module__m-r-24___bwaNL {
  margin-right: 24px !important;
}

.Caregivers-module__m-r-30___mSTzr {
  margin-right: 30px !important;
}

.Caregivers-module__m-r-40___SDlpC {
  margin-right: 40px !important;
}

.Caregivers-module__border-r-3___dA6ck {
  border-radius: 3px !important;
}

.Caregivers-module__border-r-4___A7uhO {
  border-radius: 4px !important;
}

.Caregivers-module__border-r-6___EPNYW {
  border-radius: 6px !important;
}

.Caregivers-module__border-r-10___uDN25 {
  border-radius: 10px !important;
}

.Caregivers-module__border-r-12___JjwoL {
  border-radius: 12px !important;
}

.Caregivers-module__border-r-16___yWzcg {
  border-radius: 16px !important;
}

.Caregivers-module__border-r-50___rVeZq {
  border-radius: 50% !important;
}

.Caregivers-module__primary-border___SBauX {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-b___KYd9m {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-t___WWbjh {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-l___n_4Bu {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-r___hF2aC {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__secondary-border___fgGKx {
  border: 1px solid #637768;
}

.Caregivers-module__secondary-border-b___IY8Zw {
  border-bottom: 1px solid #637768;
}

.Caregivers-module__secondary-border-t___M67XF {
  border-top: 1px solid #637768;
}

.Caregivers-module__secondary-border-l___ZUlpj {
  border-left: 1px solid #637768;
}

.Caregivers-module__secondary-border-r___ln0vW {
  border-right: 1px solid #637768;
}

.Caregivers-module__gap-0___gtRlO {
  gap: 0 !important;
}

.Caregivers-module__gap-2___ENM0m {
  gap: 2px !important;
}

.Caregivers-module__gap-4___hBEy6 {
  gap: 4px !important;
}

.Caregivers-module__gap-5___eS2iQ {
  gap: 5px !important;
}

.Caregivers-module__gap-6___vOW32 {
  gap: 6px !important;
}

.Caregivers-module__gap-8___EcBLt {
  gap: 8px !important;
}

.Caregivers-module__gap-10___rkWCa {
  gap: 10px !important;
}

.Caregivers-module__gap-12___iwMjJ {
  gap: 12px !important;
}

.Caregivers-module__gap-14___S50zM {
  gap: 14px !important;
}

.Caregivers-module__gap-16___PBWHt {
  gap: 16px !important;
}

.Caregivers-module__gap-18___TRVln {
  gap: 18px !important;
}

.Caregivers-module__gap-20___fOP9p {
  gap: 20px !important;
}

.Caregivers-module__gap-24___xoHlD {
  gap: 24px !important;
}

.Caregivers-module__gap-26___pdydG {
  gap: 26px !important;
}

.Caregivers-module__gap-30___EEBja {
  gap: 30px !important;
}

.Caregivers-module__gap-32___JQgV4 {
  gap: 32px !important;
}

.Caregivers-module__gap-40___qm36j {
  gap: 40px !important;
}

.Caregivers-module__gap-50___dttEs {
  gap: 50px !important;
}

.Caregivers-module__flex-1___rzSOY {
  flex: 1;
}

.Caregivers-module__flex-none___aTp96 {
  flex: none !important;
}

.Caregivers-module__flex-column___pvHmp {
  display: flex;
  flex-direction: column !important;
}

.Caregivers-module__flex-row___E9Y21 {
  display: flex;
  flex-direction: row !important;
}

.Caregivers-module__vertically-centered___HtaJv {
  display: flex;
  align-items: center !important;
}

.Caregivers-module__horizontally-centered___eTbUU {
  display: flex;
  justify-content: center !important;
}

.Caregivers-module__horizontally-end___teFcH {
  display: flex;
  justify-content: end !important;
}

.Caregivers-module__vertically-start___o4X5b {
  display: flex;
  align-items: start !important;
}

.Caregivers-module__space-between___j2yp0 {
  display: flex;
  justify-content: space-between !important;
}

.Caregivers-module__flex-wrap___FMso_ {
  flex-wrap: wrap !important;
}

.Caregivers-module__height-100___QkXC9 {
  height: 100%;
}

.Caregivers-module__width-50___Rfuxj {
  width: 50% !important;
}

.Caregivers-module__width-100___K2v_a {
  width: 100%;
}

.Caregivers-module__cursor-pointer___n9IvG {
  cursor: pointer;
}

.Caregivers-module__cursor-not-allowed___PJ24x {
  cursor: not-allowed !important;
}

.Caregivers-module__absolute-centered___B0jin {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Caregivers-module__absolute___yFd2U {
  position: absolute;
}

.Caregivers-module__relative___ELJ3L {
  position: relative;
}

.Caregivers-module__fixed___ek3PX {
  position: fixed;
}

.Caregivers-module__visible___YGrQp {
  opacity: 1;
}

.Caregivers-module__invisible___fji17 {
  opacity: 0;
}

.Caregivers-module__col-90___W0YYV {
  width: 90% !important;
}

.Caregivers-module__col-auto___zTzI6 {
  width: auto !important;
}

.Caregivers-module__medical-tabs___uMU22 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Caregivers-module__medical-table-new___J9IPJ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Caregivers-module__medical-table-new___J9IPJ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Caregivers-module__medical-table-new___J9IPJ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Caregivers-module__medical-table-new___J9IPJ::-webkit-scrollbar-track {
  display: none;
}
.Caregivers-module__medical-table-new___J9IPJ.Caregivers-module__no-pagination___i_tgO {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Caregivers-module__medical-table-new___J9IPJ.Caregivers-module__no-pagination___i_tgO:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Caregivers-module__medical-table-new___J9IPJ.Caregivers-module__no-pagination___i_tgO::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Caregivers-module__medical-table-new___J9IPJ.Caregivers-module__no-pagination___i_tgO::-webkit-scrollbar-track {
  display: none;
}

.Caregivers-module__medical-table-empty___GA81j {
  padding: 14px 40px !important;
}

.Caregivers-module__icon-btn___QuDIu {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Caregivers-module__search-icon___de6nZ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Caregivers-module__disable-select___ZQYmL {
  user-select: none;
}

.Caregivers-module__break-word___GPEVa {
  word-break: break-word;
}

.Caregivers-module__popup-clear-btn___ei7kw {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Caregivers-module__scroll-m-b-20___G972O {
  scroll-margin-bottom: 20px;
}

.Caregivers-module__rightContent___zSZec {
  justify-content: space-between;
}
.Caregivers-module__rightContent___zSZec .Caregivers-module__label___dMrD_ {
  color: #637768;
}
.Caregivers-module__rightContent___zSZec .Caregivers-module__select___Pp9k5 {
  min-width: 140px;
}
.Caregivers-module__rightContent___zSZec .Caregivers-module__select___Pp9k5 > div:first-child {
  padding: 4.5px !important;
}
.Caregivers-module__rightContent___zSZec .Caregivers-module__button___WK07j {
  height: 38px;
  margin: -8px 0 8px 0;
}

.Caregivers-module__availabilityBanner___DfwBZ {
  background: #fff3d0;
  border: 1.5px solid #f1bf72;
  border-radius: 6px;
  padding: 6px 12px;
  color: #375844;
}
.Caregivers-module__availabilityBanner___DfwBZ .Caregivers-module__label___dMrD_ {
  color: #375844;
}

.Caregivers-module__availabilityTitle___L3KkY {
  color: #637768;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Caregivers/Caregivers.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,8BAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA3pBE;EACE,gBAAA;AA6pBJ;AA3pBI;EACE,yBAAA;AA6pBN;AAzpBE;EACE,YAAA;EACA,oBAAA;AA2pBJ;;AAvpBA;EACE,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA0pBF;AAxpBE;EACE,cAAA;AA0pBJ;;AAtpBA;EACE,cAAA;AAypBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.rightContent {\n  justify-content: space-between;\n\n  .label {\n    color: get-color(greenNew, medium-dark);\n  }\n\n  .select {\n    min-width: 140px;\n\n    & > div:first-child {\n      padding: 4.5px !important;\n    }\n  }\n\n  .button {\n    height: 38px;\n    margin: -8px 0 8px 0;\n  }\n}\n\n.availabilityBanner {\n  background: get-color(orange, base);\n  border: 1.5px solid get-color(orangeNew, base);\n  border-radius: 6px;\n  padding: 6px 12px;\n  color: get-color(greenNew, dark);\n\n  .label {\n    color: get-color(greenNew, dark);\n  }\n}\n\n.availabilityTitle {\n  color: get-color(greenNew, medium-dark);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Caregivers-module__font-s-10___nKddB`,
	"fontS12": `Caregivers-module__font-s-12___Htne_`,
	"fontS13": `Caregivers-module__font-s-13___vNkSj`,
	"fontS14": `Caregivers-module__font-s-14___QF0eZ`,
	"fontS15": `Caregivers-module__font-s-15___WAixI`,
	"fontS16": `Caregivers-module__font-s-16___yOdS0`,
	"fontS18": `Caregivers-module__font-s-18___oJT1j`,
	"fontS20": `Caregivers-module__font-s-20___P78JS`,
	"fontS22": `Caregivers-module__font-s-22___c_ZBJ`,
	"fontS28": `Caregivers-module__font-s-28___mrBcN`,
	"fontW400": `Caregivers-module__font-w-400___BXDWN`,
	"fontW500": `Caregivers-module__font-w-500___AKvYH`,
	"fontW600": `Caregivers-module__font-w-600___bVckh`,
	"fontW700": `Caregivers-module__font-w-700___UlhqK`,
	"p5": `Caregivers-module__p-5___aDhjv`,
	"p12": `Caregivers-module__p-12___srYSE`,
	"p16": `Caregivers-module__p-16___lpLC_`,
	"p30": `Caregivers-module__p-30___ZIwoZ`,
	"pB0": `Caregivers-module__p-b-0___YGl9J`,
	"pB5": `Caregivers-module__p-b-5___UzKN2`,
	"pB10": `Caregivers-module__p-b-10___BvTLP`,
	"pB12": `Caregivers-module__p-b-12___v60VV`,
	"pB16": `Caregivers-module__p-b-16___QaybZ`,
	"pB18": `Caregivers-module__p-b-18___zihI7`,
	"pB20": `Caregivers-module__p-b-20___x37cV`,
	"pB25": `Caregivers-module__p-b-25___Y7lSP`,
	"pB30": `Caregivers-module__p-b-30___ogUDZ`,
	"pB50": `Caregivers-module__p-b-50___kYkjH`,
	"pT0": `Caregivers-module__p-t-0___vZMzh`,
	"pT12": `Caregivers-module__p-t-12___LmNGo`,
	"pT16": `Caregivers-module__p-t-16___T3Hrc`,
	"pT18": `Caregivers-module__p-t-18___vD2JH`,
	"pT20": `Caregivers-module__p-t-20___eBAjR`,
	"pT30": `Caregivers-module__p-t-30___ViLFQ`,
	"pT40": `Caregivers-module__p-t-40___orXn7`,
	"pT50": `Caregivers-module__p-t-50___Ykzoc`,
	"pL20": `Caregivers-module__p-l-20___mNPT8`,
	"pL30": `Caregivers-module__p-l-30___rE9xv`,
	"pL40": `Caregivers-module__p-l-40___lMhzE`,
	"pR16": `Caregivers-module__p-r-16___CUxfc`,
	"pR20": `Caregivers-module__p-r-20___Gi_3H`,
	"pR30": `Caregivers-module__p-r-30___YljDW`,
	"pR50": `Caregivers-module__p-r-50___sOdDh`,
	"pR60": `Caregivers-module__p-r-60___cCHE2`,
	"mB1": `Caregivers-module__m-b-1___S28Cy`,
	"mB2": `Caregivers-module__m-b-2___PdoSX`,
	"mB6": `Caregivers-module__m-b-6___VRVoi`,
	"mB8": `Caregivers-module__m-b-8___IBa9B`,
	"mB10": `Caregivers-module__m-b-10___JnaiQ`,
	"mB14": `Caregivers-module__m-b-14___Oz1UR`,
	"mB16": `Caregivers-module__m-b-16___rGAMj`,
	"mB20": `Caregivers-module__m-b-20___PMpUT`,
	"mB22": `Caregivers-module__m-b-22___j5QwL`,
	"mB24": `Caregivers-module__m-b-24___WqH9O`,
	"mB30": `Caregivers-module__m-b-30___kc39a`,
	"mB32": `Caregivers-module__m-b-32___XUvbF`,
	"mB40": `Caregivers-module__m-b-40___rxxLS`,
	"mT2": `Caregivers-module__m-t-2___PEiOk`,
	"mT3": `Caregivers-module__m-t-3___NIHTx`,
	"mT4": `Caregivers-module__m-t-4___q9sZI`,
	"mT5": `Caregivers-module__m-t-5___q8tVi`,
	"mT8": `Caregivers-module__m-t-8___Ge3R5`,
	"mT10": `Caregivers-module__m-t-10___HGcLC`,
	"mT15": `Caregivers-module__m-t-15___qjsIz`,
	"mT16": `Caregivers-module__m-t-16___dD5AR`,
	"mT20": `Caregivers-module__m-t-20___xjAZr`,
	"mT22": `Caregivers-module__m-t-22___ZIzTP`,
	"mT30": `Caregivers-module__m-t-30___XrAbX`,
	"mT32": `Caregivers-module__m-t-32___c5ewu`,
	"mLAuto": `Caregivers-module__m-l-auto___P9Uxk`,
	"mL4": `Caregivers-module__m-l-4___s1bCJ`,
	"mL5": `Caregivers-module__m-l-5___yhWZC`,
	"mL6": `Caregivers-module__m-l-6___WU5SE`,
	"mL8": `Caregivers-module__m-l-8___beZSr`,
	"mL10": `Caregivers-module__m-l-10___PqSIC`,
	"mL16": `Caregivers-module__m-l-16____9jyS`,
	"mL20": `Caregivers-module__m-l-20___ajvZC`,
	"mL24": `Caregivers-module__m-l-24___YTij6`,
	"mL30": `Caregivers-module__m-l-30___yNDde`,
	"mL35": `Caregivers-module__m-l-35___GAeLk`,
	"mL40": `Caregivers-module__m-l-40___rkGgU`,
	"mR8": `Caregivers-module__m-r-8___spZHz`,
	"mR10": `Caregivers-module__m-r-10___XB83t`,
	"mR16": `Caregivers-module__m-r-16___nEVGf`,
	"mR20": `Caregivers-module__m-r-20___syhtC`,
	"mR24": `Caregivers-module__m-r-24___bwaNL`,
	"mR30": `Caregivers-module__m-r-30___mSTzr`,
	"mR40": `Caregivers-module__m-r-40___SDlpC`,
	"borderR3": `Caregivers-module__border-r-3___dA6ck`,
	"borderR4": `Caregivers-module__border-r-4___A7uhO`,
	"borderR6": `Caregivers-module__border-r-6___EPNYW`,
	"borderR10": `Caregivers-module__border-r-10___uDN25`,
	"borderR12": `Caregivers-module__border-r-12___JjwoL`,
	"borderR16": `Caregivers-module__border-r-16___yWzcg`,
	"borderR50": `Caregivers-module__border-r-50___rVeZq`,
	"primaryBorder": `Caregivers-module__primary-border___SBauX`,
	"primaryBorderB": `Caregivers-module__primary-border-b___KYd9m`,
	"primaryBorderT": `Caregivers-module__primary-border-t___WWbjh`,
	"primaryBorderL": `Caregivers-module__primary-border-l___n_4Bu`,
	"primaryBorderR": `Caregivers-module__primary-border-r___hF2aC`,
	"secondaryBorder": `Caregivers-module__secondary-border___fgGKx`,
	"secondaryBorderB": `Caregivers-module__secondary-border-b___IY8Zw`,
	"secondaryBorderT": `Caregivers-module__secondary-border-t___M67XF`,
	"secondaryBorderL": `Caregivers-module__secondary-border-l___ZUlpj`,
	"secondaryBorderR": `Caregivers-module__secondary-border-r___ln0vW`,
	"gap0": `Caregivers-module__gap-0___gtRlO`,
	"gap2": `Caregivers-module__gap-2___ENM0m`,
	"gap4": `Caregivers-module__gap-4___hBEy6`,
	"gap5": `Caregivers-module__gap-5___eS2iQ`,
	"gap6": `Caregivers-module__gap-6___vOW32`,
	"gap8": `Caregivers-module__gap-8___EcBLt`,
	"gap10": `Caregivers-module__gap-10___rkWCa`,
	"gap12": `Caregivers-module__gap-12___iwMjJ`,
	"gap14": `Caregivers-module__gap-14___S50zM`,
	"gap16": `Caregivers-module__gap-16___PBWHt`,
	"gap18": `Caregivers-module__gap-18___TRVln`,
	"gap20": `Caregivers-module__gap-20___fOP9p`,
	"gap24": `Caregivers-module__gap-24___xoHlD`,
	"gap26": `Caregivers-module__gap-26___pdydG`,
	"gap30": `Caregivers-module__gap-30___EEBja`,
	"gap32": `Caregivers-module__gap-32___JQgV4`,
	"gap40": `Caregivers-module__gap-40___qm36j`,
	"gap50": `Caregivers-module__gap-50___dttEs`,
	"flex1": `Caregivers-module__flex-1___rzSOY`,
	"flexNone": `Caregivers-module__flex-none___aTp96`,
	"flexColumn": `Caregivers-module__flex-column___pvHmp`,
	"flexRow": `Caregivers-module__flex-row___E9Y21`,
	"verticallyCentered": `Caregivers-module__vertically-centered___HtaJv`,
	"horizontallyCentered": `Caregivers-module__horizontally-centered___eTbUU`,
	"horizontallyEnd": `Caregivers-module__horizontally-end___teFcH`,
	"verticallyStart": `Caregivers-module__vertically-start___o4X5b`,
	"spaceBetween": `Caregivers-module__space-between___j2yp0`,
	"flexWrap": `Caregivers-module__flex-wrap___FMso_`,
	"height100": `Caregivers-module__height-100___QkXC9`,
	"width50": `Caregivers-module__width-50___Rfuxj`,
	"width100": `Caregivers-module__width-100___K2v_a`,
	"cursorPointer": `Caregivers-module__cursor-pointer___n9IvG`,
	"cursorNotAllowed": `Caregivers-module__cursor-not-allowed___PJ24x`,
	"absoluteCentered": `Caregivers-module__absolute-centered___B0jin`,
	"absolute": `Caregivers-module__absolute___yFd2U`,
	"relative": `Caregivers-module__relative___ELJ3L`,
	"fixed": `Caregivers-module__fixed___ek3PX`,
	"visible": `Caregivers-module__visible___YGrQp`,
	"invisible": `Caregivers-module__invisible___fji17`,
	"col90": `Caregivers-module__col-90___W0YYV`,
	"colAuto": `Caregivers-module__col-auto___zTzI6`,
	"medicalTabs": `Caregivers-module__medical-tabs___uMU22`,
	"medicalTableNew": `Caregivers-module__medical-table-new___J9IPJ`,
	"noPagination": `Caregivers-module__no-pagination___i_tgO`,
	"medicalTableEmpty": `Caregivers-module__medical-table-empty___GA81j`,
	"iconBtn": `Caregivers-module__icon-btn___QuDIu`,
	"searchIcon": `Caregivers-module__search-icon___de6nZ`,
	"disableSelect": `Caregivers-module__disable-select___ZQYmL`,
	"breakWord": `Caregivers-module__break-word___GPEVa`,
	"popupClearBtn": `Caregivers-module__popup-clear-btn___ei7kw`,
	"scrollMB20": `Caregivers-module__scroll-m-b-20___G972O`,
	"rightContent": `Caregivers-module__rightContent___zSZec`,
	"label": `Caregivers-module__label___dMrD_`,
	"select": `Caregivers-module__select___Pp9k5`,
	"button": `Caregivers-module__button___WK07j`,
	"availabilityBanner": `Caregivers-module__availabilityBanner___DfwBZ`,
	"availabilityTitle": `Caregivers-module__availabilityTitle___L3KkY`
};
module.exports = ___CSS_LOADER_EXPORT___;
